import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SessionContextProvider } from '@supabase/auth-helpers-react';
import { supabase } from './lib/supabase';
import { captureReferralSource } from './utils/referralTracking';
import { renderBehindSnapshot } from './lib/prerenderSwap';
import App from './App.tsx';
import './index.css';

captureReferralSource();

const rootEl = document.getElementById('root')!;
const app = (
  <StrictMode>
    <SessionContextProvider supabaseClient={supabase}>
      <App />
    </SessionContextProvider>
  </StrictMode>
);

// scripts/postbuild.js stamps prerendered pages with their route. index.html marks
// (and hides) a snapshot served for a different route as stale.
const html = document.documentElement;
if (html.hasAttribute('data-stale-prerender')) {
  rootEl.replaceChildren();
  html.removeAttribute('data-stale-prerender');
}

if (html.hasAttribute('data-prerender-path') && rootEl.firstElementChild) {
  renderBehindSnapshot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    import('./lib/sentry').then(({ initSentry }) => initSentry());
  });
} else {
  setTimeout(() => {
    import('./lib/sentry').then(({ initSentry }) => initSentry());
  }, 2000);
}